// git push -u origin main
import React, { useState } from 'react';
import BikeImage1 from '../../../assets/BikeImage1.png';
import { FaArrowLeft } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const MobileMoreDetails = () => {
    // State to handle modal visibility
    const [isModalOpen, setIsModalOpen] = useState(false);
    const navigate = useNavigate();

    // Function to toggle modal visibility
    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };
    const handleBack = () => {
        navigate(0);
    };
    return (
        <>
            <div className="flex justify-center h-screen border rounded-lg bg-gray-100 w-full">

                <div className="w-full bg-white rounded-lg p-8">
                    <p className='text-lg text-[#FF9630]'>Booking Summary</p>
                    {/* Image of Vehicle */}
                    <div className="flex justify-center mb-2">
                        <img src={BikeImage1} alt="Hero Glamour Xtec 125 N" className="h-40" />
                    </div>
                    <div className="text-center font-semibold text-xl mt-4">Hero Glamour Xtec 125 N</div>
                    {/* Ride Details Grid with Borders */}

                    <div className="grid grid-cols-2 gap-y-1 text-md mt-5 text-gray-700">

                        <div className="col-span-2 border border-gray-300 rounded-md p-2 mb-2">
                            <div className="flex justify-between font-semibold">
                                <p className="text-left">Total Amount</p>
                                <p className="text-right">₹0.00</p>
                            </div>
                            <div className="flex justify-between font-semibold mt-4">
                                <p className="text-left">Total Refund Amount</p>
                                <p className="text-right">₹0.00</p>
                            </div>
                            <div className="flex justify-between  ">
                                <p className="text-left">Total Amount Paid</p>
                                <p className="text-right">₹0.00</p>
                            </div>
                            <div className="flex justify-between">
                                <p className="text-left">Convenience Fees</p>
                                <p className="text-right">₹0.00</p>
                            </div>
                            <div className="flex justify-between">
                                <p className="text-left">Cancellation Fees</p>
                                <p className="text-right">₹862.00</p>
                            </div>
                            <div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default MobileMoreDetails;